<template>
  <div class=''>

    <div>
      <input
      id='uploadInput'
      type="file"
      class='width_full no-render'
      @change='uploadStart'>
    </div>

    <div class="row">
      <div class="grid-4">
        <button
          :disabled="disabled"
          class="width_full upload-button"
          :class="uploadButtonClass"
          @click='uploadInit'>
          {{ (file) ? `Upload File:&emsp;${file.name}` : 'Select Excel Document'}}
        </button>
      </div>
      <div class="grid-4">
        <button
          class="width_full primary-green-bg"
          @click='downloadTemplateMerchant'>
          Download Template
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import { mouseEventTrigger } from 'src/components/shared/helper/mouseEvents'
import { mapActions, mapGetters } from 'vuex'
import {
  SET_MODAL_CONFIG_ACTION,
  MODAL_RESPONSE_GETTER,
  ACTION_DOWNLOAD_MERCHANT_TEMPLATE,
  GET_DOWNLOAD_ERROR
} from '../../store/NameSpace'

export default {
  data () {
    return {
      file: null
    }
  },
  props: ['period', 'uploadFile', 'disabled', 'clearUploadButtonText'],
  methods: {
    ...mapActions({
      pop: SET_MODAL_CONFIG_ACTION,
      actionDownloadMerchantTemplate: ACTION_DOWNLOAD_MERCHANT_TEMPLATE
    }),
    uploadInit () {
      let uploadInput = document.getElementById('uploadInput')
      uploadInput.value = ''
      mouseEventTrigger(uploadInput, 'click')
    },
    uploadStart (event) {
      this.file = event.target.files[0]
      let extension = this.file.name.split('.').pop()
      if (extension !== 'xlsx' && extension !== 'xls') {
        this.file = null
        this.pop({
          header: 'Invalid File',
          message: '.xlsx, .xls are the only supported file types',
          buttons: {
            accept: {
              text: 'Try again'
            }
          },
          type: 'ERROR'
        })
      } else {
        this.checkFileSize(this.file)
      }
    },
    uploadFileInitiate () {
      this.uploadFile(this.file)
    },
    checkFileSize (file) {
      if (('size' in file) && (file.size / 1048576) > 1) {
        this.pop({
          header: 'Alert',
          message: `Are you sure to upload file of size ${(file.size / 1048576).toFixed(3) + ' Mb?'}`,
          buttons: {
            accept: {
              text: 'OK'
            },
            decline: {
              text: 'CANCEL',
              present: true
            }
          },
          type: null
        })
      } else {
        this.uploadFileInitiate(file)
      }
    },
    downloadTemplateMerchant () {
      this.actionDownloadMerchantTemplate()
    }
  },
  computed: {
    ...mapGetters({
      modalResponse: MODAL_RESPONSE_GETTER,
      gettersDownloadError: GET_DOWNLOAD_ERROR
    }),
    uploadButtonClass () {
      return {
        'primary-green-bg': !this.disabled,
        'primary-text-grey': this.disabled
      }
    }
  },
  watch: {
    modalResponse () {
      // if (this.modalResponse) {
      //   this.uploadFileInitiate()
      // } else {
      //   this.file = null
      // }
    },
    clearUploadButtonText () {
      if (this.clearUploadButtonText) {
        this.file = null
      }
    },
    'gettersDownloadError' () {
      this.pop({
        header: 'Download Failed!',
        message: this.gettersDownloadError,
        type: 'ERROR'
      })
    }
  }
}
</script>

<style scoped>
.no-render {
  display: none;
}
#uploadFileName {
  text-transform: uppercase;
  font-size: 1.4rem;
  padding: 1.1rem 1rem;
}
.word-wrap {
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// Upload.vue?466016af